<template>
  <div class="loader ease-linear rounded-full border-8 border-t-8"></div>
</template>
<script>
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'SLoading',
})
</script>
<style>
.loader {
  border-top-color: #fe5000;
  -webkit-animation: spinner 1.5s linear infinite;
  animation: spinner 1.5s linear infinite;
}

@-webkit-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spinner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
